import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import TextInput from "../../form/TextInput";
import Select from "../../form/Select";
import AddressControl from "../../form/AddressControl";

class MembercardForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <TextInput
                            {...this.props.getFieldProps("issuelocation.name")}
                            name="issuelocation.name"
                            value={(this.props.values.issuelocation || {}).name}
                            label="Átadás helye"
                            saveChanges={this.props.setFieldValue}
                            disabled={true}
                        />
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="barcode"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Vonalkód"
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-8">
                        <div className="form-group">
                            <Select
                                storeType="remote"
                                disabled={!!parseInt(this.props.values.registered || "0")}
                                {...this.props.getFieldProps("user")}
                                name="user"
                                component="user"
                                value={this.props.values.user}
                                label="Felhasználó"
                                objectValue={true}
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="form-group">
                            <TextInput
                                {...this.props.getFieldProps("user.email")}
                                name="user.email"
                                value={this.props.values.user?.email}
                                label="E-mail"
                                saveChanges={this.props.setFieldValue}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="form-group">
                            <div className="row">
                                <AddressControl
                                    value={this.props.values.user?.address}
                                    label="Cím"
                                    disabled={true}
                                    saveChanges={this.props.setFieldValue}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(MembercardForm);
